import { defineMessages } from "react-intl";

export const actionMessages = defineMessages({
  fromUrlNotSpecified: {
    defaultMessage: "Form can't be submitted: url is not specified.",
    id: "actions.form-url-not-specified",
  },
});
